import { css } from '@lastbrand/web-ui-styled-system/css'

export const selectedGroupItemLabelClass = css({
  fontWeight: 400,
})

export const optionRowDsClass = css({
  display: 'flex',
  flexFlow: 'row wrap',
  alignItems: 'center',
  paddingTop: 'space-12',
  gap: 'space-8',
})
